import { jsx as _jsx } from "react/jsx-runtime";
import { MessageRole } from '../../types/message.types';
import { MessageMetadata } from '../AssistantMessageList/styles';
import { ModelBadge } from './Model';
import { UserBadge } from './User';
const MessageBadge = ({ message }) => {
    if (message.role === MessageRole.ASSISTANT && !!message.author_id)
        return (_jsx(MessageMetadata, { children: _jsx(ModelBadge, { modelId: message.author_id }) }));
    if (message.role === MessageRole.USER)
        return (_jsx(MessageMetadata, { style: { justifyContent: 'flex-end' }, children: _jsx(UserBadge, { authorId: message.author_id, authorType: message.author_type }) }));
    return null;
};
export default MessageBadge;
